/** React Router's URL path */
export const PATH = '/summarytimesheet_report'

/** title on the layout header */
export const HEADER = 'Summary Timesheet Report'

/** module's redux state name */
export const REDUCER_NAME = 'summarytimesheet_report'

export const MODULE = {
  RESET: `${REDUCER_NAME}/MODULE.RESET`,
}

export const GET_REPORT = {
  REQUEST: `${REDUCER_NAME}/GET_REPORT.REQUEST`,
  SUCCESS: `${REDUCER_NAME}/GET_REPORT.SUCCESS`,
  FAILURE: `${REDUCER_NAME}/GET_REPORT.FAILURE`,
}

export const GET_EXPORT = {
  REQUEST: `${REDUCER_NAME}/GET_EXPORT.REQUEST`,
  SUCCESS: `${REDUCER_NAME}/GET_EXPORT.SUCCESS`,
  FAILURE: `${REDUCER_NAME}/GET_EXPORT.FAILURE`,
  RESET: `${REDUCER_NAME}/GET_EXPORT.RESET`,
}

export const FILTER = {
  SET_FIELD: `${REDUCER_NAME}/FILTER.SET_FIELD`,
}

export const MORE_FILTER = {
  SET_FIELD: `${REDUCER_NAME}/MORE_FILTER.SET_FIELD`,
}

export const SORT = {
  SET_FIELD: `${REDUCER_NAME}/SORT.SET_FIELD`,
}



// WEBPACK FOOTER //
// ./src/pages/report/summary-timesheet/constants.js